import i18n from "../../../helpers/lang/i18n"


const t = i18n.global.t
export interface IPasswordValidate {
  containNumber: RegExp,
  containUppercase: RegExp,
  containLowercase: RegExp,
  containSymbol: RegExp,
  minLength: RegExp,
}

export const insertHtmlValidations = (passwordValidate: IPasswordValidate): void => {
  const div = document.querySelector('.inputs-password')
  const newDiv = document.createElement('div');
  newDiv.setAttribute('class', 'list-validations')
  div?.appendChild(newDiv)

  for (const property in passwordValidate) {
    const newSpan = document.createElement('span');
    newSpan.setAttribute('class', property)

    const translationMap: Record<string, string> = {
      containNumber: t('ajustes.usuarios.validaciones.debe_contener_numero'),
      containUppercase: t('ajustes.usuarios.validaciones.debe_contener_mayuscula'),
      containLowercase: t('ajustes.usuarios.validaciones.debe_contener_minuscula'),
      containSymbol: t('ajustes.usuarios.validaciones.debe_contener_simbolo'),
      minLength: t('ajustes.usuarios.validaciones.debe_contener_8_caracteres'),
    }

    if (translationMap[property]) {
      newSpan.setAttribute('data-content', translationMap[property])
    }

    newDiv?.appendChild(newSpan)
  }
}

export const validateFormat = (e: string = "", passwordValidate: IPasswordValidate) => {
  for (const property of Object.keys(passwordValidate) as (keyof IPasswordValidate)[]) {
    if (passwordValidate[property].test(e)) {
      const span = document.querySelector(`.${property}`);
      span?.setAttribute('class', `${property} valid`);
    } else {
      const span = document.querySelector(`.${property}`);
      span?.setAttribute('class', property);
    }
  }
  return e;
}
